import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useSupplierService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { ChartPeriodClickArgs } from "models/propTypes/chartProps";

const SuppliersPerMonthChart: React.FC = () => {
  const supplierService = useSupplierService();
  const labelFormatter = (label?: string) => {
    return label ? label.substring(0, 3) : "";
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Line}
      chartAPIKey={GraphConstants.ChartKeys.NumOfInvoicedSuppliersComparable}
      labelFormatter={labelFormatter}
      filterToAPIHandler={supplierService.reportToAPIFilter}
      usePageFilter={false}
      dataUnit={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Pc)}
      useClickableChart
      onDataPointClickedSetFilter={(arg) => {
        const args = arg as ChartPeriodClickArgs | undefined;
        return args?.start && args?.end ? { invoiceDate: { start: args.start, end: args.end } } : {};
      }}
      onBackgroundClickedSetFilter={{ invoiceDate: undefined }}
    />
  );
};

export default SuppliersPerMonthChart;
